<template>
  <div>
    <!-- 头部 -->
    <headerNav activeIndex=""></headerNav>
    <div class="pc">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 163px 0;
        "
      >
        <img
          src="../../assets/404.png"
          style="width: 400px; margin-right: 30px"
          alt=""
        />
        <div>
          <div class="Regular" style="font-size: 24px; color: #888">
            抱歉，您访问的页面不存在
          </div>
          <router-link
            to="/"
            style="
              height: 26px;
              line-height: 26px;
              background: linear-gradient(0deg, #719468, #3f6b33);
              color: #fff;
              text-align: center;
              display: table;
              padding: 0 16px;
              font-size: 15px;
              margin-top: 30px;
              box-shadow: 0px 2px 4px 0px rgba(63, 107, 51, 0.44);
              border-radius: 13px;
            "
          >
            返回首页
          </router-link>
        </div>
      </div>
    </div>
    <div class="mobile" style="margin-top:0.26rem;">
      <div
        style="
          padding: 1rem 0.2rem 0;
        "
      >
        <img
          src="../../assets/404.png"
          style="width: 100%;"
          alt=""
        />
        <div style="text-align:center;">
          <div class="Regular" style="font-size: 0.2rem; color: #888;margin-top:0.2rem;">
            抱歉，您访问的页面不存在
          </div>
          <router-link
            to="/"
            style="
              height: 26px;
              line-height: 26px;
              background: linear-gradient(0deg, #719468, #3f6b33);
              color: #fff;
              text-align: center;
              display: table;
              padding: 0 16px;
              font-size: 15px;
              margin: 30px auto;
              box-shadow: 0px 2px 4px 0px rgba(63, 107, 51, 0.44);
              border-radius: 13px;
            "
          >
            返回首页
          </router-link>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import footerNav from "@/components/footerNav/index";
export default {
  name: "customerSupportNav",
  components: {
    headerNav,
    footerNav,
  },
};
</script>

<style lang="sass" scoped>
</style>


// WEBPACK FOOTER //
// src/components/error/404.vue